import { render, staticRenderFns } from "./NewMembersReport.vue?vue&type=template&id=2071591a"
import script from "./NewMembersReport.vue?vue&type=script&lang=js"
export * from "./NewMembersReport.vue?vue&type=script&lang=js"
import style0 from "./NewMembersReport.vue?vue&type=style&index=0&id=2071591a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports